import { Pipe, type PipeTransform } from '@angular/core';
import { IconBigMediumDokument } from './build/Icon-BIG_Medium-Dokument.icon';
import { type BigIcon } from './build/icon.model';
import { type IconMap } from './icon-map';

@Pipe({
    name: 'iconMapToIcon',
})
export class IconMapToIconPipe implements PipeTransform {
    public transform(iconMap: IconMap, iconKey: string): BigIcon {
        let match;

        if (iconKey in iconMap) {
            match = iconMap[iconKey as BigIcon['name']];
        }

        return match ?? IconBigMediumDokument;
    }
}
